<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="
      hariLibur && hariLibur.hari_libur_id
        ? 'Ubah Hari Libur'
        : 'Tambah Hari Libur'
    "
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-alert
            v-if="!isEdit"
            class="body-2 mb-5 pb-5"
            dense text
            type="info"
          >
            Jika hanya <b>1 hari</b>, maka tgl awal dan akhir di isi samaka hari libur
            yang akan Anda tambahkan <b>lebih dari satu hari</b>.
          </v-alert>

          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row row wrap>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2">Tanggal {{ isEdit ? '' : 'Awal' }}</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Awal"
                  v-model="tanggalAwal"
                  :disabled="isDisabled"
                  hint="Tanggal Awal"
                  :max="tanggalAkhir"
                  data-vv-name="tanggalAwal"
                  data-vv-as="Tanggal Awal"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAwal')"
                ></m-datepicker>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                class="py-0"
                v-if="!isEdit"
              >
                <label class="caption mb-2">Tanggal Akhir</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Akhir"
                  v-model="tanggalAkhir"
                  :min="tanggalAwal"
                  :disabled="isDisabled"
                  hint="Tanggal Akhir"
                  data-vv-name="tanggalAkhir"
                  data-vv-as="Tanggal Akhir"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAkhir')"
                ></m-datepicker>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2">Keterangan</label>
                <v-textarea
                  dense
                  single-line
                  outlined
                  label="Keterangan"
                  v-model="hariLibur.keterangan"
                  hint="Keterangan"
                  data-vv-name="keterangan"
                  data-vv-as="Keterangan"
                  v-validate.persist="'required'"
                  rows="2"
                  :error-messages="errors.collect('form.keterangan')"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="6" class="py-0">
                <label class="caption mb-2">Jenis Hari Libur</label>
                <v-select
                  v-model="hariLibur.k_hari_libur"
                  dense
                  outlined
                  :items="[
                    { key: 1, label: 'Libur Nasional' },
                    { key: 2, label: 'Cuti Bersama' }
                   ]"
                  placeholder="Pilih Jenis Hari Libur"
                  item-value="key"
                  item-text="label"
                  data-vv-name="jenis"
                  data-vv-as="Jenis Libur"
                  v-validate.persist="'required'"
                  rows="2"
                  :error-messages="errors.collect('form.jenis')"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      rangeDate: false,
      tanggalAwal: null,
      tanggalAkhir: null,
      roles: [],
      hariLibur: {},
      isDisabled: false,
      defHariLibur: {
        tanggal: null,
        keterangan: null
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.getDeepObj(this.hariLibur, 'hari_libur_id')
    }
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.isDisabled = false;
      this.rangeDate = false;
      this.hariLibur = obj
        ? {
            ...obj,
            ...(this.isDisabled = false),
            ...(this.tanggalAwal = obj.tanggal),
            ...(this.tanggalAkhir = obj.tanggal)
          }
        : {
            ...this.defHariLibur,
            ...(this.tanggalAwal = null),
            ...(this.tanggalAkhir = null)
          };
      this.$validator.reset();
      return this.$refs.dlg.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          if (!this.isEdit) {
            this.$store
              .dispatch("hariLibur/form", {
                organisasi_id: this.organisasi_id || this.tenant_id,
                obj: {
                  id: this.hariLibur.hari_libur_id,
                  tgl_awal: this.tanggalAwal,
                  tgl_akhir: this.tanggalAkhir,
                  keterangan: this.hariLibur.keterangan,
                  kode_organisasi: this.organisasi_id || '',
                  k_hari_libur: this.hariLibur.k_hari_libur
                }
              })
              .then(() => {
                this.$refs.dlg.resolve();
              })
              .catch(e => e);
          } else {
            this.$store
              .dispatch("hariLibur/form", {
                organisasi_id: this.organisasi_id || this.tenant_id,
                obj: {
                  id: this.hariLibur.hari_libur_id,
                  tanggal: this.tanggalAwal,
                  keterangan: this.hariLibur.keterangan,
                  kode_organisasi: this.organisasi_id || '',
                  k_hari_libur: this.hariLibur.k_hari_libur
                }
              })
              .then(() => {
                this.$refs.dlg.resolve();
              })
              .catch(e => e);
          }
        })
        .catch(e => e);
    },
    changeRangeDate() {
      this.$validator.reset();
      this.rangeDate = !this.rangeDate;
    }
  },
  watch: {
    tanggalAwal() {
      this.tanggalAkhir = this.rangeDate ? this.tanggalAkhir : this.tanggalAwal;
    },
    rangeDate(r) {
      this.tanggalAkhir = r ? this.tanggalAkhir : this.tanggalAwal;
    }
  }
};
</script>
